import locationModuleMutations from "./location/mutations";

export default {
  ...locationModuleMutations,
};
